const PPColors = [
  '#30F2B8',
  '#6330F2',
  '#00B8D9',
  '#00875A',
  '#FE621D',
  '#7E78D2',
  '#FF5630',
  '#FFAB00',
  '#0065FF',
  '#F283B6'
];

const getUserInitials = (user: { name?: string; email: string }) => {
  if (user.name) {
    return user.name
      .split(' ')
      .filter(Boolean)
      .map(n => n.charAt(0).toUpperCase())
      .join('');
  }
  return user.email.charAt(0).toUpperCase();
};

const getUserPPColor = (email: string) => {
  const userCharcodesSum = email
    .split('@')[0] // we take the first part of the email
    .split('') // we get an array of letters from the string
    .map(l => l.charCodeAt(0)) // we transform every letter to its charcode
    .reduce((a, b) => a + b, 0); // we add all the charcodes
  const userColorNumber = userCharcodesSum % 10; // we get only the module 10

  return PPColors[userColorNumber];
};

export { getUserInitials, getUserPPColor };
